// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderOuterOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderOuterOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderOuterOutlinedSvg
  }));
};

BorderOuterOutlined.displayName = 'BorderOuterOutlined';
export default React.forwardRef(BorderOuterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BorderOuterOutlined.js
// module id = 663
// module chunks = 0